import React, { useState } from "react"
import { Form, Input, message } from "antd"
import Button from "src/components/MyButton/Button"
import { BlockInput, ButtonStyle } from "src/pages/ANONYMOUS/LoginPage/styled"
import IconBase from "src/components/IconBase"
import AuthService from "src/services/AuthService"

const ForgotPasswordForm = ({ setActiveTab }) => {
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const onFinish = async values => {
    setLoading(true)
    try {
      const res = await AuthService.forgotPass({ email: values.email })

      if (res.message.includes("Mật khẩu mới đã được gửi đến email của bạn.")) {
        message.success(
          res.message || "Vui lòng kiểm tra email để lấy mật khẩu mới",
        )
        setActiveTab("login")
      } else {
        form.setFields([
          {
            name: "email",
            errors: [res.message || "Có lỗi xảy ra, vui lòng thử lại"],
          },
        ])
      }
    } catch (error) {
      // Bắt lỗi 401 từ API
      if (error.response?.status === 401) {
        form.setFields([
          {
            name: "email",
            errors: [
              error.response.data?.message || "Có lỗi xảy ra, vui lòng thử lại",
            ],
          },
        ])
      } else {
        form.setFields([
          {
            name: "email",
            errors: ["Có lỗi xảy ra, vui lòng thử lại"],
          },
        ])
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: "Vui lòng nhập email" },
          { type: "email", message: "Email không hợp lệ" },
        ]}
      >
        <BlockInput>
          <IconBase name="email" />
          <Input placeholder="Nhập email" />
        </BlockInput>
      </Form.Item>

      <Form.Item>
        <ButtonStyle
          btnType="primary"
          type="submit"
          htmlType="submit"
          block
          loading={loading}
        >
          Gửi liên kết đặt lại mật khẩu
        </ButtonStyle>
      </Form.Item>

      <div className="text-center">
        <span
          onClick={() => setActiveTab("login")}
          role="button"
          className="text-primary"
          style={{ cursor: "pointer", fontSize: "14px" }}
        >
          Quay lại đăng nhập
        </span>
      </div>
    </Form>
  )
}

export default ForgotPasswordForm
